import PagedFilterAndSortedRequest from "./page-request";

// 用户数据分页请求模型
export default class UserPageRequest extends PagedFilterAndSortedRequest {
	// 当前登录用户名
	loginUserName: string;
	//当前登录用户所属社区
	loginUserCommunityId: number;
}



// WEBPACK FOOTER //
// ./src/store/entities/page-request-user.ts